// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/BulkConfirmationPopup/styles.scss
// module id = 801
// module chunks = 0